import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  standalone: false,
  name: "nameDisplay",
})
export class NameDisplayPipe implements PipeTransform {
  transform(name: string) {
    if (!name) {
      return name;
    }

    if (name.indexOf(".") !== -1) {
      const regx = /\./gi;
      const replaced = name.replace(regx, " ");
      return capitaliseInitial(replaced);
    }

    if (name.indexOf(",") !== -1) {
      const split = name.split(",").map((w) => w.trim());
      const ordered = split.length > 1 ? [...split.splice(1), split[0]] : split;
      return ordered.map(capitaliseInitial).join(" ");
    }

    return name;
  }
}

function capitaliseInitial(name: string): string {
  const split = name.split(" ");
  const transformed = split.map((w) => w[0].toUpperCase() + w.substring(1));
  return transformed.join(" ");
}
